module.exports = __webpack_public_path__ + "static/logo-b2b8d556608782fcee0183d04ab82009.svg";